/* eslint-disable react/jsx-indent */
import { IconPendingSimple } from '@tvg/fuse-icons';
import React from 'react';
import styled from 'styled-components';
import { Icon as IconElement } from '../../fuse-icon-element/src/icon-element';
import { gridConfig } from '../../fuse-responsive-grid/src/grid';
import { ListStyled } from './styled-pagination';

const IconWrapper = styled(ListStyled).attrs({
	className: 'fuse-pagination__ellipses',
	'data-testid': 'fuse-pagination__ellipses',
})`
	display: flex;
	width: var(--spacing-global-space7);
	margin-right: var(--spacing-global-space3);
	align-items: center;
	justify-content: center;

	@media screen and (max-width: ${gridConfig.s.maxWidth}) {
		width: var(--spacing-global-space5);
		margin-right: var(--spacing-global-space4);
	}
`;

export function Ellipses() {
	return (
		<IconWrapper aria-hidden>
			<IconElement
				icon={<IconPendingSimple />}
				color="var(--color-greys-grey7)"
				responsiveSize="medium"
			/>
		</IconWrapper>
	);
}

Ellipses.displayName = 'Ellipses';

export default Ellipses;
